import angular from 'angular';
import { Async, Inject } from '../../../base/decorators';
import { BasePopup, BasePopupConfiguration } from '../base-popup/component';

export class PositionCommentPopup extends BasePopup {
    @Inject('PositionService')
    positionService;

    @Async()
    async loadContent() {
        const { positionId } = this;
        const { result: comment } = await this.positionService.getPositionComment(positionId);

        if (!comment) {
            return this.$filter('translate')('JOB_DASHBORAD_COMMENT_LEAD_TEXT');
        }
        const commentHtml = comment.split('\n').map(item => `${item}<br/>`).join('');

        return `<div class="job-table-popup--title">${commentHtml}</div>`;
    }
}

export const PositionCommentPopupConfiguration = {
    ...BasePopupConfiguration,
    controller: PositionCommentPopup,
    bindings: {
        ...BasePopupConfiguration.bindings,
        positionId: '<',
    },
};

angular.module('TALENYA-FE').component('positionCommentPopup', PositionCommentPopupConfiguration);